import { useState } from "react";
import { Flame, Snowflake, TrendingDown, TrendingUp } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useSlip } from "@/context/SlipContext";

export function StreakActions({ slug, record, playingToday, size = "sm" }) {
  const { replace } = useSlip();
  const [busy, setBusy] = useState("");
  if (!playingToday) return null;
  const hot = record?.hot, cold = record?.cold;
  const primary = cold && !hot ? "fade" : "ride";
  const build = async (mode) => {
    setBusy(mode);
    try {
      const { data } = await api.post(`/players/${slug}/streak-parlay`, { mode });
      replace(data.legs, { title: data.title, strategy: data.strategy });
      toast.success(`"${data.title}" loaded — ${data.legs.length} legs in your slip`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy("");
    }
  };
  const cls = size === "lg" ? "gap-2 px-4 py-2 text-xs" : "gap-1 px-2.5 py-1 text-[10px]";
  const ico = size === "lg" ? 14 : 11;
  const Btn = ({ mode, label, Icon, main }) => (
    <button data-testid={`streak-${mode}-btn`} disabled={!!busy} onClick={() => build(mode)}
      className={`inline-flex items-center rounded-full border font-bold uppercase tracking-wider transition-[background-color,transform] duration-200 hover:-translate-y-0.5 disabled:opacity-60 ${cls} ${main ? (mode === "ride" ? "border-orange-400/70 bg-orange-500/20 text-orange-200" : "border-sky-400/70 bg-sky-500/20 text-sky-200") : "border-[#26334D] text-slate-300 hover:border-slate-400"}`}>
      <Icon size={ico} /> {busy === mode ? "Building…" : label}
    </button>
  );
  return (
    <span className="inline-flex flex-wrap items-center gap-2" data-testid="streak-actions">
      <Btn mode="ride" label={hot ? "Ride the heater" : "Ride"} Icon={hot ? Flame : TrendingUp} main={primary === "ride"} />
      <Btn mode="fade" label={cold ? "Fade the slump" : hot ? "Fade the streak" : "Fade"} Icon={cold ? Snowflake : TrendingDown} main={primary === "fade"} />
    </span>
  );
}
